<template>
    <overlay-scrollbars class="board scrollable" v-if="spread != null">
        <div  class="board__container" :class="{'--hide': needToFadeIn}">
            <div class="board__wrapper" ref="wrapper">
                <deck ref="deck"
                    :cardsNbr="spread.deck.length"
                    :maxPulledCard="5"  
                    @topCardClick="onActionBtnClick"
                />
                <button
                    class="draw-card-btn"
                    @click="onActionBtnClick"
                    :class="{'--inactive': actionCooldownTimeoutID != null}"
                >
                    {{actionBtnText}}
                </button>
                <spread-layout 
                    ref="layout"
                    v-bind="spread.result"
                />
                <interpretation ref="interpretation" :result="spread.result"/>
                <info-btn to="/about">
                    <span>i</span>
                </info-btn>
            </div>      
        </div>
        <animation-screen ref="screen" @mounted="onAnimationScreenMounted"/>
    </overlay-scrollbars>
</template>

<script>
    import 'overlayscrollbars/css/OverlayScrollbars.css';
    import { OverlayScrollbarsComponent } from 'overlayscrollbars-vue';
    import AnimationScreen from './AnimationScreen';
    import Deck from './Deck';
    import Interpretation from './Interpretation';
    import Spread from '@/lib/Spread';
    import SpreadLayout from './SpreadLayout';
    import InfoBtn from '@/components/InfoBtn'
    import Card from './Card';
    import style from '@/style/settings.scss';

    export default {
        components: {
            AnimationScreen, Deck, Interpretation, SpreadLayout, InfoBtn,
            'overlay-scrollbars': OverlayScrollbarsComponent
        },

        props: {
            introCardPos: {type: Object, required: false, default: null},
        },

        data () {return {
            spread: null,
            actionBtnPullCardText: 'Draw card',
            actionBtnResetText: "Reset",
            actionCooldownDelay: 2000,
            actionCooldownTimeoutID: null,
            actionResetReady: false,
            needToFadeIn: false,
            introCardId: null,
        }},

        computed: {
            hasBegin () {
                return this.spread.hasBegin;
            },
            isDone () {
                return this.spread.done;
            },
            actionBtnText () {
                if (this.isDone) return this.actionBtnResetText
                else return this.actionBtnPullCardText
            },
            isLastAction () {
                return this.spread.actionCounter == this.spread.nbrOfActions
            }
        },

        watch: {
            'spread.hasBegin': function (newVal) {
                if (newVal) this.$nextTick(() => {
                    this.spread.setLayoutDimension()
                })
            },
        },

        created () {
            window.board = this;
            window.Card = Card;

            this.spread = new Spread(
                $store.cards, $store.spreadLayout, $store.spreadActions,
                this.onResize.bind(this)
            );
            window.addEventListener('resize', this.spread.setLayoutDimension.bind(this.spread));

            if (
                this.introCardPos != null   &&
                $store.firstPage  == "Home" &&
                $store.lastPage   == null
            )
                this.needToFadeIn = true;

        },

        mounted () {
            this.$nextTick(() => {
                this.spread.setLayoutDimension();
            });
            
            if (
                this.introCardPos != null   &&
                $store.firstPage  == "Home" &&
                $store.lastPage   == null
            )
                this.drawIntro();
    
        },

        deactivated () {
            $store.lastPage = this.$route.name;
        },

        methods: {

            animeIntro () {

                if (this.introCardId != null) {

                    let topCardPos = this.$refs.deck.getTopCardPosition();

                    this.$refs.screen.animeActor(
                        this.introCardId,
                        [
                            {
                                duration: style.boardIntroTransition,
                                x: topCardPos.left,
                                y: topCardPos.top, 
                                scale: 1,
                            },
                        ],
                        () => {
                            this.needToFadeIn = false;
                            this.$refs.screen.drawStartMessage();
                        }
                    );

                    this.introCardId = null;
                }
            },

            drawIntro () {
                let scale = (
                    window.innerWidth < style.cardXsBreakpoint
                        ? style.cardXsZoomScale
                        : style.cardZoomScale
                );
        
                this.introCardId = this.$refs.screen.registerActor({
                    component: Card,
                    componentProps: {slug: 'verso'},
                    class: ['--flipped'],
                    x: this.introCardPos.x,
                    y: this.introCardPos.y,
                    scale: scale,
                });
                
                this.$nextTick(() => {
                    this.animeIntro();
                })

            },

            onActionBtnClick () {
                if (this.isDone) {
                    if (this.actionResetReady) {
                        this.actionResetReady = false;
                        this.reset();
                    }
                }
                else {
                    if (this.hasBegin == false) this.$refs.screen.removeStartMessage();
      
                    this.pullCard();
                }
            },

            onAnimationScreenMounted () {
                if ($store.lastPage != null && $store.firstPage != "Home")
                    this.$refs.screen.drawStartMessage();
            },

            onResize (payload) {
                this.$refs.layout.setSlotsPositions(payload)
            },

            pullCard () {

                let payload = this.spread.next()
                if (payload == false) return

                let toX = (
                        this.$el.getElementsByClassName('board__container')[0].offsetLeft,
                        // this.$refs.wrapper.offsetLeft +
                        this.$refs.layout.$el.offsetLeft +
                        payload.slot.x
                    ),
                    toY = this.$refs.layout.$el.offsetTop  + payload.slot.y,
                    topDeckPos = this.$refs.deck.getTopCardPosition(),
                    steps;


                switch ($store.screenSize) {
                    case 'xs':
                        steps = this.getXsAnimationSteps(toX, toY, this.spread.getCard(payload.slug), payload.slot.slug);
                        break;
                    default:
                        steps = this.getMdAnimationSteps(toX, toY, this.spread.getCard(payload.slug), payload.slot.slug);
                }

                this.$refs.screen.anime(
                    {
                        component: Card,
                        componentProps: {slug: payload.slug},
                        x: topDeckPos.left,
                        y: topDeckPos.top,
                        class: ["--flipped"]
                    },
                    steps,
                    (removeCard) => {

                        this.$refs.layout.setCardSlot(payload.slot.slug, payload.slug);

                        removeCard();

                        if (this.isLastAction) {

                            if (this.actionCooldownTimeoutID == null) {
                                this.actionCooldownTimeoutID = setTimeout(() => {
                                    this.actionResetReady = true;
                                    this.actionCooldownTimeoutID = null;
                                }, this.actionCooldownDelay)
                            }
                        }

                    },
                    false // autoDelete (after end of animation) mode
                );


            },

            getXsAnimationSteps (toX, toY, card, layoutPos) {

                let middleX = (this.$el.offsetWidth / 2) - (parseInt(style.cardXsWidth) / 2),
                    middleY = (this.$el.offsetHeight/ 2) - (parseInt(style.cardXsHeight));

                return [
                    {x: middleX, y: middleY, scale: style.cardXsZoomScale, onComplete: cardActor => {

                        cardActor.class = [];

                        setTimeout(() => {
                           this.$refs.interpretation.set(layoutPos, card)
                        }, style.cardFlipAnimationDelay - 120);

                    }},
                    {delay: 1000, x: toX , y: toY, scale: 1},
                ]

            },

            getMdAnimationSteps (toX, toY, card, layoutPos) {

                return [
                    {x: toX, y: toY, onComplete: cardActor => {
                        cardActor.class = []
                    }},
                    {delay: 0, onStart: cardActor => {
                        setTimeout(() => {
                            this.$refs.interpretation.set(layoutPos, card)
                        }, style.cardFlipAnimationDelay - 120)
                        // this.$refs.interpretation.set(layoutPos, card)
                    }}
                ]
            
            },

            reset () {
                this.spread.reset();
                this.$refs.layout.reset();
                this.$refs.interpretation.reset();

                this.$refs.screen.drawStartMessage();
            },

        }
    }
</script>